var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "manage-bank" },
    [
      _c("h2", [_vm._v("Банковские счета")]),
      _vm._v(" "),
      _c(_setup.WaitMessage, { attrs: { ob: _setup.listob } }),
      _vm._v(" "),
      _setup.listob.message
        ? _c(
            "button",
            {
              staticClass: "btn",
              attrs: { type: "button", disabled: _setup.busy },
              on: {
                click: function ($event) {
                  return _setup.load()
                },
              },
            },
            [_vm._v("Повторить загрузку")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_setup.listob.wait && !_setup.listob.message
        ? _c(
            "div",
            [
              !_setup.accounts.length
                ? _c("p", [_vm._v("Банковские счета не добавлены")])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_setup.accounts, function (account) {
                return _c("div", { key: account.id, staticClass: "account" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.selectedId,
                          expression: "selectedId",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        name: "bank-account",
                        disabled: _setup.busy,
                      },
                      domProps: {
                        value: account.id,
                        checked: _vm._q(_setup.selectedId, account.id),
                      },
                      on: {
                        click: function ($event) {
                          return _setup.choose(account)
                        },
                        change: function ($event) {
                          _setup.selectedId = account.id
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("Счёт " + _vm._s(account.anumber)),
                      _c("br"),
                      _vm._v("БИК " + _vm._s(account.bik)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btndot",
                      attrs: { type: "button", disabled: _setup.busy },
                      on: {
                        click: function ($event) {
                          return _setup.remove(account)
                        },
                      },
                    },
                    [_vm._v("Удалить")]
                  ),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.WaitMessage, { attrs: { ob: _setup.actionob } }),
      _vm._v(" "),
      _c("h3", [_vm._v("Добавить счёт")]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _setup.add.apply(null, arguments)
            },
          },
        },
        [
          _c("label", { staticClass: "line" }, [
            _c("span", [_vm._v("Номер счёта")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _setup.anumber,
                  expression: "anumber",
                },
              ],
              attrs: {
                type: "text",
                inputmode: "numeric",
                name: "anumber",
                size: "20",
                disabled: _setup.busy,
              },
              domProps: { value: _setup.anumber },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _setup.anumber = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "line" }, [
            _c("span", [_vm._v("БИК")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _setup.bik,
                  expression: "bik",
                },
              ],
              attrs: {
                type: "text",
                inputmode: "numeric",
                name: "bik",
                size: "9",
                disabled: _setup.busy,
              },
              domProps: { value: _setup.bik },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _setup.bik = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _setup.validationMessage
            ? _c(
                "div",
                { staticClass: "error-list", attrs: { role: "alert" } },
                [_vm._v(_vm._s(_setup.validationMessage))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.WaitMessage, { attrs: { ob: _setup.addob } }),
          _vm._v(" "),
          _c("div", { staticClass: "buttons" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--blue",
                attrs: {
                  type: "submit",
                  disabled: _setup.busy || !!_setup.listob.message,
                },
              },
              [_vm._v("Добавить")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: { type: "button", disabled: _setup.busy },
                on: { click: _setup.back },
              },
              [_vm._v("Вернуться")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }